module.exports = __webpack_public_path__ + "static/media/image_banner_b2c.124f6250.png";